<script setup>
  const props = defineProps(['to']);
  const target = useLinkTarget(props.to);
</script>

<!----------------------------------------------------------------------------->

<template>
  <NuxtLink :to="props.to" :target="target" class="card"><slot /></NuxtLink>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  a {
    display: block;
    cursor: pointer;
  }
</style>
